import { conf } from '../fe-inv-conf'
import { initTokenManager } from '@meisterwerk/fe-authentication-sdk'
import { authSession } from './auth-session'
import { sessionSource } from './embedded-session-source'
import { removeRetiredTokenKeys } from './retired-token-keys'
import { LOGIN_PATH } from './session-storage-contracts'

let isAuthInitialized = false
/**
 * Whether this page started embedded with no token stored. The PWA stores its token before any
 * route mounts fe-inv, so none means a wrong VITE_HOST_TOKEN_PREFIX, or a PWA that changed that
 * order.
 */
let startedWithoutHostToken = false

/**
 * Must run once on app boot (before anything that calls `createTRPCAuth()`).
 * `src/index.tsx` calls this for that reason.
 */
export function initAuth() {
  if (isAuthInitialized) return
  isAuthInitialized = true
  removeRetiredTokenKeys()
  initTokenManager({
    authApiUrl: conf.AUTH_API_URL, // Base URL for Auth API
    refreshWindowSeconds: 60, // Refresh 1 min before expiration
    // The PWA's key set: its sign-in, sign-out or switch of user reaches the next request (INV-927)
    keyPrefix: conf.HOST_TOKEN_PREFIX,
    // On a refusal the SDK clears the tokens and calls onLogout, else every request would fail
    // with "trpc token missing"; authSession decides between the login page and an ended notice
    loginPath: LOGIN_PATH,
    onLogout: authSession.handleSdkLogout,
    // A refresh that fails without a refusal keeps the tokens: a connection problem (INV-924)
    onRefreshError: authSession.handleSdkRefreshError,
  })
  authSession.noteStoredSession()
  startedWithoutHostToken = sessionSource.isSignedOutHere()
}

/** Sends startedWithoutHostToken once; app.tsx calls it after initSentry(), which runs later */
export function reportMissingHostToken(send: (message: string) => unknown): void {
  if (!startedWithoutHostToken) return
  startedWithoutHostToken = false
  send(
    `fe-inv started embedded with no token stored under the key prefix "${conf.HOST_TOKEN_PREFIX}"`,
  )
}

// IMPORTANT:
// This must run during module evaluation (before `router.tsx` imports `trpc.ts` which calls `createTRPCAuth()`).
// Keeping it idempotent makes it safe to import from multiple places.
initAuth()
